var _ = function _(t) {
    return t;
  },
  _t,
  _t2,
  _t3,
  _t4,
  _t5,
  _t6,
  _t7,
  _t8;
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.symbol.to-primitive.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.date.to-primitive.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.promise.js";
import "core-js/modules/es.reflect.construct.js";
import "core-js/modules/es.reflect.get.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.regexp.to-string.js";
import "core-js/modules/web.dom-collections.iterator.js";
function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(self, call) { if (call && (typeof call === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _get() { if (typeof Reflect !== "undefined" && Reflect.get) { _get = Reflect.get.bind(); } else { _get = function _get(target, property, receiver) { var base = _superPropBase(target, property); if (!base) return; var desc = Object.getOwnPropertyDescriptor(base, property); if (desc.get) { return desc.get.call(arguments.length < 3 ? target : receiver); } return desc.value; }; } return _get.apply(this, arguments); }
function _superPropBase(object, property) { while (!Object.prototype.hasOwnProperty.call(object, property)) { object = _getPrototypeOf(object); if (object === null) break; } return object; }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
import { html, LitElement } from 'lit';
import { helper } from "../../common/helper";
import css from './style.pcss';
import * as dayjs from "dayjs";
import Flickity from "flickity";
import customParseFormat from "dayjs/plugin/customParseFormat";
import PlayIcon from "../../common/images/play_icon.svg";
dayjs.extend(customParseFormat);
var RTLTodayRadioSchedule = /*#__PURE__*/function (_LitElement) {
  _inherits(RTLTodayRadioSchedule, _LitElement);
  function RTLTodayRadioSchedule() {
    var _this;
    _classCallCheck(this, RTLTodayRadioSchedule);
    _this = _callSuper(this, RTLTodayRadioSchedule);
    _this.date = dayjs().format('YYYY-MM-DD');
    _this.dates = _this._getDateRange(7);
    _this.loading = false;
    return _this;
  }
  _createClass(RTLTodayRadioSchedule, [{
    key: "createRenderRoot",
    value: function createRenderRoot() {
      return this;
    }
  }, {
    key: "connectedCallback",
    value: function connectedCallback() {
      _get(_getPrototypeOf(RTLTodayRadioSchedule.prototype), "connectedCallback", this).call(this);

      /*
      let nDate;
      if (window.location.hash) {
          nDate = window.location.hash.substring(1);
          if (dayjs(nDate, 'YYYY-MM-DD').isValid()) {
               let found = false;
              this.dates.map(date => {
                  if (date.isSame(dayjs(nDate, 'YYYY-MM-DD'))) found = true;
              });
               if (found) {
                  this.date = dayjs(nDate, 'YYYY-MM-DD').format('YYYY-MM-DD');
              } else {
                  this.date = dayjs().format('YYYY-MM-DD');
                  window.location.hash = this.date
              }
          }
      }
      */

      this._fetchData();
    }
  }, {
    key: "_getDateRange",
    value: function _getDateRange(days) {
      var dates = [];
      var startDate = dayjs().set('hour', 0).set('minute', 0).set('second', 0).subtract(days, 'day');
      var endDate = dayjs().set('hour', 0).set('minute', 0).set('second', 0).add(days, 'day');
      while (startDate.isBefore(endDate)) {
        dates = [].concat(_toConsumableArray(dates), [startDate]);
        startDate = startDate.add(1, 'day');
      }
      return dates;
    }
  }, {
    key: "_fetchData",
    value: function _fetchData() {
      var _this2 = this;
      this.loading = true;
      this.apiUrl = `https://api-gate.rtl.lu/on-air/rtltodayradio/program/${this.date}`;
      fetch(this.apiUrl).then(function (resp) {
        return resp.json();
      }).then(function (resp) {
        _this2.data = resp;
        _this2.loading = false;
      });
    }
  }, {
    key: "_gotoDate",
    value: function _gotoDate(e, date) {
      //window.location.href = `/radio#${date.format('YYYY-MM-DD')}`;
      this.date = date.format('YYYY-MM-DD');
      this._fetchData();
    }
  }, {
    key: "render",
    value: function render() {
      var _this3 = this;
      if (this.data == undefined) return html(_t || (_t = _`Loading...`));
      this.updateComplete.then(function () {
        if (!_this3.flickity) {
          var slider = _this3.querySelector('.schedule-nav');
          _this3.flickity = new Flickity(slider, {
            cellAlign: 'left',
            contain: true,
            pageDots: false,
            initialIndex: 7
          });
        }
      });
      return html(_t2 || (_t2 = _`
            <style>${0}</style>
            <div class="schedule-nav">
                ${0}
            </div>

            <div class="schedule">
                ${0}
                ${0}
            </div>
        `), css, this.dates.map(function (date) {
        var today;
        if (dayjs(_this3.date, 'YYYY-MM-DD', true).isSame(dayjs(date), 'day')) {
          today = ' schedule-nav__item--today';
        }
        return html(_t3 || (_t3 = _`
                        <div class="schedule-nav__item${0}" @click="${0}">
                            <div class="schedule-nav__date">
                                ${0}
                                ${0}
                            </div>
                        </div>
                    `), today, function (e) {
          return _this3._gotoDate(e, date);
        }, dayjs().format('D/M/YYYY') === date.format('D/M/YYYY') ? html(_t4 || (_t4 = _`<h3>Today</h3>`)) : html(_t5 || (_t5 = _`<h3>${0}</h3>`), date.format('dddd')), date.format('D. MMM YYYY'));
      }), this.loading ? html(_t6 || (_t6 = _`
                    <div class="loading">
                        <div class="loading__indicator"><div></div><div></div><div></div><div></div></div>
                    </div>
                `)) : '', this.data.map(function (item) {
        return html(_t7 || (_t7 = _`
                        <div class="schedule__item">
                            <div class="schedule__time">${0} - ${0}</div>
                            <div class="schedule__content">
                                <div class="schedule__image">
                                    <img src="${0}" alt="${0}" />
                                </div>

                                <div class="schedule__show">${0}</div>
                                <div class="schedule__link">
                                    ${0}
                                </div>
                            </div>
                        </div>
                    `), helper.time2eng(item.start_time), helper.time2eng(item.end_time), item.crew.image, item.crew.name, item.show.name, item.show.url ? html(_t8 || (_t8 = _`
                                        <a class="schedule-button" style="background-image: url('${0}');" href="${0}" target="_blank"><span>Listen</span></a>
                                    `), PlayIcon, item.show.url) : '');
      }));
    }
  }], [{
    key: "properties",
    get: function get() {
      return {
        data: {
          type: String
        },
        loading: {
          type: Boolean
        }
      };
    }
  }]);
  return RTLTodayRadioSchedule;
}(LitElement);
export { RTLTodayRadioSchedule as default };
window.customElements.define('rtl-today-radio-schedule', RTLTodayRadioSchedule);